export default __webpack_public_path__ + "static/pendantfront-b26e0f3c60d970ca3e62218949411070.png";